import type { ImgHTMLAttributes } from 'react'
import classNames from 'classnames'

import styles from './styles/BlueLogo.css'

type BlueLogoProps = ImgHTMLAttributes<HTMLImageElement> & { alt: string }

// The blue Scite wordmark, deepened on light surfaces and left at its own lighter blue in dark.
const BlueLogo = ({ className, alt, ...props }: BlueLogoProps) => (
  <img
    {...props}
    alt={alt}
    className={classNames(styles.logo, className)}
    src={`${CONFIG.assetsBaseURL}/images/logo-blue.svg`}
  />
)

export default BlueLogo
